import React from 'react';
import { PiggyBank, Calendar, DollarSign } from 'lucide-react';

/**
 * Компонент для настройки досрочного погашения
 */
const EarlyRepaymentSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  earlyRepaymentPeriods 
}) => {
  if (!formData.includeEarlyRepayment) return null;

  return (
    <div className="mb-6 bg-gradient-to-r from-purple-50 to-violet-50 dark:from-purple-900/10 dark:to-violet-900/10 p-5 rounded-lg border border-purple-200 dark:border-purple-800/50 shadow-sm">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
        <PiggyBank className="w-5 h-5 text-purple-500" />
        Досрочное погашение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-1 text-purple-500" />
            Сумма досрочного платежа
          </label>
          <input
            type="text"
            id="earlyRepaymentAmount"
            name="earlyRepaymentAmount"
            value={formData.earlyRepaymentAmount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentAmount ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.earlyRepaymentAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentAmount}
            </p>
          )}
        </div>

        {/* Период досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentPeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-1 text-purple-500" />
            Периодичность
          </label>
          <select
            id="earlyRepaymentPeriod"
            name="earlyRepaymentPeriod"
            value={formData.earlyRepaymentPeriod}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.earlyRepaymentPeriod ? 'input-error' : ''}`}
          >
            {earlyRepaymentPeriods.map((period) => (
              <option key={period.id} value={period.id}>
                {period.name}
              </option>
            ))}
          </select>
          {errors.earlyRepaymentPeriod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentPeriod}
            </p>
          )}
        </div>

        {/* Месяц начала досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentStartMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-1 text-purple-500" />
            Начать с месяца
          </label>
          <input
            type="text"
            id="earlyRepaymentStartMonth"
            name="earlyRepaymentStartMonth"
            value={formData.earlyRepaymentStartMonth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentStartMonth ? 'input-error' : ''}`}
            placeholder="Номер месяца"
          />
          {errors.earlyRepaymentStartMonth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentStartMonth}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 text-sm text-purple-700 dark:text-purple-300 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-700">
        <div className="flex items-start">
          <PiggyBank className="w-5 h-5 text-purple-500 mr-2 mt-0.5" />
          <div>
            <p className="font-medium">Как работает досрочное погашение?</p>
            <p className="text-xs mt-1">
              В зависимости от выбранной цели рефинансирования (снижение платежа или срока), при досрочном погашении будет либо уменьшаться ежемесячный платеж, либо сокращаться срок кредита.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarlyRepaymentSection;